/* eslint-disable */
/* istanbul ignore file */
/*
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODE-GENERATOR !!!
 * !!! DO NOT MODIFY THIS FILE BY YOURSELF  !!!
 */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export var Chat_ChatBanEventType;
(function (Chat_ChatBanEventType) {
    Chat_ChatBanEventType["ChatBanCreated"] = "CHAT_BAN_CREATED";
    Chat_ChatBanEventType["ChatBanDeleted"] = "CHAT_BAN_DELETED";
})(Chat_ChatBanEventType || (Chat_ChatBanEventType = {}));
export var Chat_ChatEventType;
(function (Chat_ChatEventType) {
    Chat_ChatEventType["ChatUpdated"] = "CHAT_UPDATED";
})(Chat_ChatEventType || (Chat_ChatEventType = {}));
export var CommerceV2_CommerceProvider;
(function (CommerceV2_CommerceProvider) {
    CommerceV2_CommerceProvider["Target"] = "Target";
})(CommerceV2_CommerceProvider || (CommerceV2_CommerceProvider = {}));
/** Represents an ISO 4217 Currency Code: https://en.wikipedia.org/wiki/ISO_4217 */
export var CommerceV2_CurrencyCode;
(function (CommerceV2_CurrencyCode) {
    CommerceV2_CurrencyCode["Aed"] = "AED";
    CommerceV2_CurrencyCode["Afn"] = "AFN";
    CommerceV2_CurrencyCode["All"] = "ALL";
    CommerceV2_CurrencyCode["Amd"] = "AMD";
    CommerceV2_CurrencyCode["Ang"] = "ANG";
    CommerceV2_CurrencyCode["Aoa"] = "AOA";
    CommerceV2_CurrencyCode["Ars"] = "ARS";
    CommerceV2_CurrencyCode["Aud"] = "AUD";
    CommerceV2_CurrencyCode["Awg"] = "AWG";
    CommerceV2_CurrencyCode["Azn"] = "AZN";
    CommerceV2_CurrencyCode["Bam"] = "BAM";
    CommerceV2_CurrencyCode["Bbd"] = "BBD";
    CommerceV2_CurrencyCode["Bdt"] = "BDT";
    CommerceV2_CurrencyCode["Bgn"] = "BGN";
    CommerceV2_CurrencyCode["Bhd"] = "BHD";
    CommerceV2_CurrencyCode["Bnd"] = "BND";
    CommerceV2_CurrencyCode["Bob"] = "BOB";
    CommerceV2_CurrencyCode["Brl"] = "BRL";
    CommerceV2_CurrencyCode["Bsd"] = "BSD";
    CommerceV2_CurrencyCode["Btn"] = "BTN";
    CommerceV2_CurrencyCode["Bwp"] = "BWP";
    CommerceV2_CurrencyCode["Byr"] = "BYR";
    CommerceV2_CurrencyCode["Bzd"] = "BZD";
    CommerceV2_CurrencyCode["Cad"] = "CAD";
    CommerceV2_CurrencyCode["Cdf"] = "CDF";
    CommerceV2_CurrencyCode["Chf"] = "CHF";
    CommerceV2_CurrencyCode["Clp"] = "CLP";
    CommerceV2_CurrencyCode["Cny"] = "CNY";
    CommerceV2_CurrencyCode["Cop"] = "COP";
    CommerceV2_CurrencyCode["Crc"] = "CRC";
    CommerceV2_CurrencyCode["Czk"] = "CZK";
    CommerceV2_CurrencyCode["Dkk"] = "DKK";
    CommerceV2_CurrencyCode["Dop"] = "DOP";
    CommerceV2_CurrencyCode["Dzd"] = "DZD";
    CommerceV2_CurrencyCode["Egp"] = "EGP";
    CommerceV2_CurrencyCode["Etb"] = "ETB";
    CommerceV2_CurrencyCode["Eur"] = "EUR";
    CommerceV2_CurrencyCode["Fjd"] = "FJD";
    CommerceV2_CurrencyCode["Gbp"] = "GBP";
    CommerceV2_CurrencyCode["Gel"] = "GEL";
    CommerceV2_CurrencyCode["Ghs"] = "GHS";
    CommerceV2_CurrencyCode["Gmd"] = "GMD";
    CommerceV2_CurrencyCode["Gtq"] = "GTQ";
    CommerceV2_CurrencyCode["Gyd"] = "GYD";
    CommerceV2_CurrencyCode["Hkd"] = "HKD";
    CommerceV2_CurrencyCode["Hnl"] = "HNL";
    CommerceV2_CurrencyCode["Hrk"] = "HRK";
    CommerceV2_CurrencyCode["Htg"] = "HTG";
    CommerceV2_CurrencyCode["Huf"] = "HUF";
    CommerceV2_CurrencyCode["Idr"] = "IDR";
    CommerceV2_CurrencyCode["Ils"] = "ILS";
    CommerceV2_CurrencyCode["Inr"] = "INR";
    CommerceV2_CurrencyCode["Isk"] = "ISK";
    CommerceV2_CurrencyCode["Jep"] = "JEP";
    CommerceV2_CurrencyCode["Jmd"] = "JMD";
    CommerceV2_CurrencyCode["Jod"] = "JOD";
    CommerceV2_CurrencyCode["Jpy"] = "JPY";
    CommerceV2_CurrencyCode["Kes"] = "KES";
    CommerceV2_CurrencyCode["Kgs"] = "KGS";
    CommerceV2_CurrencyCode["Khr"] = "KHR";
    CommerceV2_CurrencyCode["Kmf"] = "KMF";
    CommerceV2_CurrencyCode["Krw"] = "KRW";
    CommerceV2_CurrencyCode["Kwd"] = "KWD";
    CommerceV2_CurrencyCode["Kyd"] = "KYD";
    CommerceV2_CurrencyCode["Kzt"] = "KZT";
    CommerceV2_CurrencyCode["Lak"] = "LAK";
    CommerceV2_CurrencyCode["Lbp"] = "LBP";
    CommerceV2_CurrencyCode["Lkr"] = "LKR";
    CommerceV2_CurrencyCode["Lrd"] = "LRD";
    CommerceV2_CurrencyCode["Lsl"] = "LSL";
    CommerceV2_CurrencyCode["Ltl"] = "LTL";
    CommerceV2_CurrencyCode["Lvl"] = "LVL";
    CommerceV2_CurrencyCode["Mad"] = "MAD";
    CommerceV2_CurrencyCode["Mdl"] = "MDL";
    CommerceV2_CurrencyCode["Mga"] = "MGA";
    CommerceV2_CurrencyCode["Mkd"] = "MKD";
    CommerceV2_CurrencyCode["Mmk"] = "MMK";
    CommerceV2_CurrencyCode["Mnt"] = "MNT";
    CommerceV2_CurrencyCode["Mop"] = "MOP";
    CommerceV2_CurrencyCode["Mur"] = "MUR";
    CommerceV2_CurrencyCode["Mvr"] = "MVR";
    CommerceV2_CurrencyCode["Mwk"] = "MWK";
    CommerceV2_CurrencyCode["Mxn"] = "MXN";
    CommerceV2_CurrencyCode["Myr"] = "MYR";
    CommerceV2_CurrencyCode["Mzn"] = "MZN";
    CommerceV2_CurrencyCode["Nad"] = "NAD";
    CommerceV2_CurrencyCode["Ngn"] = "NGN";
    CommerceV2_CurrencyCode["Nio"] = "NIO";
    CommerceV2_CurrencyCode["Nok"] = "NOK";
    CommerceV2_CurrencyCode["Npr"] = "NPR";
    CommerceV2_CurrencyCode["Nzd"] = "NZD";
    CommerceV2_CurrencyCode["Omr"] = "OMR";
    CommerceV2_CurrencyCode["Pen"] = "PEN";
    CommerceV2_CurrencyCode["Pgk"] = "PGK";
    CommerceV2_CurrencyCode["Php"] = "PHP";
    CommerceV2_CurrencyCode["Pkr"] = "PKR";
    CommerceV2_CurrencyCode["Pln"] = "PLN";
    CommerceV2_CurrencyCode["Pyg"] = "PYG";
    CommerceV2_CurrencyCode["Qar"] = "QAR";
    CommerceV2_CurrencyCode["Ron"] = "RON";
    CommerceV2_CurrencyCode["Rsd"] = "RSD";
    CommerceV2_CurrencyCode["Rub"] = "RUB";
    CommerceV2_CurrencyCode["Rwf"] = "RWF";
    CommerceV2_CurrencyCode["Sar"] = "SAR";
    CommerceV2_CurrencyCode["Sbd"] = "SBD";
    CommerceV2_CurrencyCode["Scr"] = "SCR";
    CommerceV2_CurrencyCode["Sdg"] = "SDG";
    CommerceV2_CurrencyCode["Sek"] = "SEK";
    CommerceV2_CurrencyCode["Sgd"] = "SGD";
    CommerceV2_CurrencyCode["Srd"] = "SRD";
    CommerceV2_CurrencyCode["Std"] = "STD";
    CommerceV2_CurrencyCode["Syp"] = "SYP";
    CommerceV2_CurrencyCode["Thb"] = "THB";
    CommerceV2_CurrencyCode["Tmt"] = "TMT";
    CommerceV2_CurrencyCode["Tnd"] = "TND";
    CommerceV2_CurrencyCode["Try"] = "TRY";
    CommerceV2_CurrencyCode["Ttd"] = "TTD";
    CommerceV2_CurrencyCode["Twd"] = "TWD";
    CommerceV2_CurrencyCode["Tzs"] = "TZS";
    CommerceV2_CurrencyCode["Uah"] = "UAH";
    CommerceV2_CurrencyCode["Ugx"] = "UGX";
    CommerceV2_CurrencyCode["Usd"] = "USD";
    CommerceV2_CurrencyCode["Uyu"] = "UYU";
    CommerceV2_CurrencyCode["Uzs"] = "UZS";
    CommerceV2_CurrencyCode["Vef"] = "VEF";
    CommerceV2_CurrencyCode["Vnd"] = "VND";
    CommerceV2_CurrencyCode["Vuv"] = "VUV";
    CommerceV2_CurrencyCode["Wst"] = "WST";
    CommerceV2_CurrencyCode["Xaf"] = "XAF";
    CommerceV2_CurrencyCode["Xcd"] = "XCD";
    CommerceV2_CurrencyCode["Xof"] = "XOF";
    CommerceV2_CurrencyCode["Xpf"] = "XPF";
    CommerceV2_CurrencyCode["Yer"] = "YER";
    CommerceV2_CurrencyCode["Zar"] = "ZAR";
    CommerceV2_CurrencyCode["Zmw"] = "ZMW";
})(CommerceV2_CurrencyCode || (CommerceV2_CurrencyCode = {}));
export var CommerceV2_SaleEventType;
(function (CommerceV2_SaleEventType) {
    CommerceV2_SaleEventType["SaleCreated"] = "SALE_CREATED";
    CommerceV2_SaleEventType["SaleDeleted"] = "SALE_DELETED";
    CommerceV2_SaleEventType["SaleUpdated"] = "SALE_UPDATED";
})(CommerceV2_SaleEventType || (CommerceV2_SaleEventType = {}));
/** The state of the plugin */
export var PluginState;
(function (PluginState) {
    PluginState["Disabled"] = "disabled";
    PluginState["Enabled"] = "enabled";
})(PluginState || (PluginState = {}));
export const GrantResultFragmentDoc = gql `
    fragment GrantResult on Chat_GrantResult {
  userId
  pubnubAccessToken
  roomKey
  isBanned
  hasWriteAccess
}
    `;
export const ChatBanFragmentDoc = gql `
    fragment ChatBan on Chat_ChatBan {
  id
  userId
  displayName
  createdAt
  expiresAt
  sourceName
}
    `;
export const BaseChatFragmentDoc = gql `
    fragment BaseChat on Chat_Chat {
  __typename
  id
  profanityFilterEnabled
  exactMatchBannedWords
  partialMatchBannedWords
  customBannedWords
  apiKey
}
    `;
export const PluginFieldsFragmentDoc = gql `
    fragment PluginFields on Plugin {
  id
  pluginDefinition {
    key
  }
  state
  options
}
    `;
export const ChatPreferencesDocument = gql `
    query chatPreferences {
  instance: chat_instance {
    __typename
    id
    publicChat {
      ...BaseChat
    }
  }
}
    ${BaseChatFragmentDoc}`;
/**
 * __useChatPreferencesQuery__
 *
 * To run a query within a React component, call `useChatPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatPreferencesQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ChatPreferencesDocument, options);
}
export function useChatPreferencesLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ChatPreferencesDocument, options);
}
export const UpdateChatPreferencesDocument = gql `
    mutation updateChatPreferences($profanityFilterEnabled: Boolean, $customBannedWords: [String!]) {
  updatePublicChatPreferences: chat_updatePublicChatPreferences(
    profanityFilterEnabled: $profanityFilterEnabled
    customBannedWords: $customBannedWords
  ) {
    __typename
    id
    publicChat {
      ...BaseChat
    }
  }
}
    ${BaseChatFragmentDoc}`;
/**
 * __useUpdateChatPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateChatPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatPreferencesMutation, { data, loading, error }] = useUpdateChatPreferencesMutation({
 *   variables: {
 *      profanityFilterEnabled: // value for 'profanityFilterEnabled'
 *      customBannedWords: // value for 'customBannedWords'
 *   },
 * });
 */
export function useUpdateChatPreferencesMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateChatPreferencesDocument, options);
}
export const GetPublicChatAccessDocument = gql `
    query getPublicChatAccess {
  chat_publicChatAccess {
    ...GrantResult
  }
}
    ${GrantResultFragmentDoc}`;
/**
 * __useGetPublicChatAccessQuery__
 *
 * To run a query within a React component, call `useGetPublicChatAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicChatAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicChatAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicChatAccessQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPublicChatAccessDocument, options);
}
export function useGetPublicChatAccessLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPublicChatAccessDocument, options);
}
export const ValidateDisplayNameDocument = gql `
    query validateDisplayName($displayName: String!) {
  chat_validateDisplayName(displayName: $displayName)
}
    `;
/**
 * __useValidateDisplayNameQuery__
 *
 * To run a query within a React component, call `useValidateDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateDisplayNameQuery({
 *   variables: {
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useValidateDisplayNameQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ValidateDisplayNameDocument, options);
}
export function useValidateDisplayNameLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ValidateDisplayNameDocument, options);
}
export const BanUserFromPublicChatDocument = gql `
    mutation banUserFromPublicChat($channelId: String!, $userId: String!, $displayName: String!, $sourceName: String!) {
  chat_banUserFromPublicChat(
    channelId: $channelId
    userId: $userId
    displayName: $displayName
    sourceName: $sourceName
  ) {
    ...ChatBan
  }
}
    ${ChatBanFragmentDoc}`;
/**
 * __useBanUserFromPublicChatMutation__
 *
 * To run a mutation, you first call `useBanUserFromPublicChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanUserFromPublicChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banUserFromPublicChatMutation, { data, loading, error }] = useBanUserFromPublicChatMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      userId: // value for 'userId'
 *      displayName: // value for 'displayName'
 *      sourceName: // value for 'sourceName'
 *   },
 * });
 */
export function useBanUserFromPublicChatMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(BanUserFromPublicChatDocument, options);
}
export const UnbanUserFromPublicChatDocument = gql `
    mutation unbanUserFromPublicChat($channelId: String!, $userId: String!, $sourceName: String!) {
  chat_unbanUserFromPublicChat(
    channelId: $channelId
    userId: $userId
    sourceName: $sourceName
  ) {
    ...ChatBan
  }
}
    ${ChatBanFragmentDoc}`;
/**
 * __useUnbanUserFromPublicChatMutation__
 *
 * To run a mutation, you first call `useUnbanUserFromPublicChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnbanUserFromPublicChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unbanUserFromPublicChatMutation, { data, loading, error }] = useUnbanUserFromPublicChatMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      userId: // value for 'userId'
 *      sourceName: // value for 'sourceName'
 *   },
 * });
 */
export function useUnbanUserFromPublicChatMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UnbanUserFromPublicChatDocument, options);
}
export const RegenerateChatApiKeyDocument = gql `
    mutation regenerateChatApiKey {
  chat_regenerateApiKey {
    id
    publicChat {
      id
      apiKey
    }
  }
}
    `;
/**
 * __useRegenerateChatApiKeyMutation__
 *
 * To run a mutation, you first call `useRegenerateChatApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateChatApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateChatApiKeyMutation, { data, loading, error }] = useRegenerateChatApiKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegenerateChatApiKeyMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RegenerateChatApiKeyDocument, options);
}
export const GetChatBansDocument = gql `
    query getChatBans($channelId: String!) {
  chat_chatBans(channelId: $channelId) {
    ...ChatBan
  }
}
    ${ChatBanFragmentDoc}`;
/**
 * __useGetChatBansQuery__
 *
 * To run a query within a React component, call `useGetChatBansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatBansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatBansQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChatBansQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetChatBansDocument, options);
}
export function useGetChatBansLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetChatBansDocument, options);
}
export const ChatBanEventDocument = gql `
    subscription chatBanEvent {
  chat_chatBanEvent {
    id
    chatBan {
      ...ChatBan
    }
  }
}
    ${ChatBanFragmentDoc}`;
/**
 * __useChatBanEventSubscription__
 *
 * To run a query within a React component, call `useChatBanEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatBanEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatBanEventSubscription({
 *   variables: {
 *   },
 * });
 */
export function useChatBanEventSubscription(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSubscription(ChatBanEventDocument, options);
}
export const GrantResultUpdatedDocument = gql `
    subscription grantResultUpdated($channelId: String!, $userId: String!) {
  chat_grantResultUpdated(channelId: $channelId, userId: $userId) {
    ...GrantResult
  }
}
    ${GrantResultFragmentDoc}`;
/**
 * __useGrantResultUpdatedSubscription__
 *
 * To run a query within a React component, call `useGrantResultUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGrantResultUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrantResultUpdatedSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGrantResultUpdatedSubscription(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSubscription(GrantResultUpdatedDocument, options);
}
export const EnablePluginsDocument = gql `
    mutation enablePlugins($command: EnablePluginsInput!) {
  enablePlugins(command: $command) {
    ...PluginFields
  }
}
    ${PluginFieldsFragmentDoc}`;
/**
 * __useEnablePluginsMutation__
 *
 * To run a mutation, you first call `useEnablePluginsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnablePluginsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enablePluginsMutation, { data, loading, error }] = useEnablePluginsMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useEnablePluginsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(EnablePluginsDocument, options);
}
export const DisablePluginsDocument = gql `
    mutation DisablePlugins($command: DisablePluginsInput!) {
  disablePlugins(command: $command) {
    ...PluginFields
  }
}
    ${PluginFieldsFragmentDoc}`;
/**
 * __useDisablePluginsMutation__
 *
 * To run a mutation, you first call `useDisablePluginsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisablePluginsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disablePluginsMutation, { data, loading, error }] = useDisablePluginsMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useDisablePluginsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DisablePluginsDocument, options);
}
export const UpdatePluginsDocument = gql `
    mutation updatePlugins($command: UpdatePluginsInput!) {
  updatePlugins(command: $command) {
    ...PluginFields
  }
}
    ${PluginFieldsFragmentDoc}`;
/**
 * __useUpdatePluginsMutation__
 *
 * To run a mutation, you first call `useUpdatePluginsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePluginsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePluginsMutation, { data, loading, error }] = useUpdatePluginsMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useUpdatePluginsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdatePluginsDocument, options);
}
export const PluginsDocument = gql `
    query Plugins($channelId: String!, $cursor: String) {
  plugins(channelId: $channelId, cursor: $cursor) {
    plugins {
      ...PluginFields
    }
  }
}
    ${PluginFieldsFragmentDoc}`;
/**
 * __usePluginsQuery__
 *
 * To run a query within a React component, call `usePluginsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePluginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePluginsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePluginsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(PluginsDocument, options);
}
export function usePluginsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(PluginsDocument, options);
}
export const OnPluginEventDocument = gql `
    subscription onPluginEvent($channelId: String!) {
  pluginEvent(channelId: $channelId) {
    event
    plugin {
      ...PluginFields
    }
  }
}
    ${PluginFieldsFragmentDoc}`;
/**
 * __useOnPluginEventSubscription__
 *
 * To run a query within a React component, call `useOnPluginEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPluginEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPluginEventSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useOnPluginEventSubscription(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSubscription(OnPluginEventDocument, options);
}
